import React, { Component } from 'react';
import PropTypes from 'prop-types';
import * as connectedWidgets from '../ConnectedWidgets';

export default class Panels extends Component {
  static propTypes = {
    colorScheme: PropTypes.func,
    className: PropTypes.string,
    widgets: PropTypes.array
  };

  renderWidgets = () => Object.keys(this.state.widgets).map(widget => {
    const Widget = connectedWidgets[widget];
    const widgetProps = this.state.widgets[widget];
    return (<Widget {...widgetProps} />)
  })

  zoom = (chartName) => () => {
    if (this.state.widgets[chartName].className === 'zoomedOut')
      return this.setState({
        widgets: {
          ...this.state.widgets,
          [chartName]: {
            ...this.state.widgets[chartName],
            height: 300,
            width: window.innerWidth * 0.9,
            className: 'zoomedIn'
          }
        }
      })
    return this.setState({
      widgets: {
        ...this.state.widgets,
        [chartName]: {
          ...this.state.widgets[chartName],
          height: 300,
          width: window.innerWidth * 0.425,
          className: 'zoomedOut'
        }
      }
    })
  }

  render() {
    return (<div>panel</div>);
  }
}



// WEBPACK FOOTER //
// ./src/components/Panels/Panels.js